import React from 'react'
import OriginalAllEmployees from 'app/Components/Employees/AllEmployees'

const AllEmployees = () => {
  return <OriginalAllEmployees />
}

export default AllEmployees
